import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const mainCarousel = document.querySelector('.sf-carousel');
  if (mainCarousel) {
  const mainCarouselSlider = mainCarousel.querySelector('.sf-carousel__slider');
    new Swiper(mainCarouselSlider, {
      modules: [Autoplay, Navigation, Pagination],
      loop: true,
      speed: 500,
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
      },
      slidesPerView: 1,
      navigation: {
        nextEl: mainCarousel.querySelector('.sf-carousel__arrow_next'),
        prevEl: mainCarousel.querySelector('.sf-carousel__arrow_prev'),
      },
      pagination: {
        el: mainCarousel.querySelector('.sf-pagination'),
        bulletClass: 'sf-pagination__bullet',
        bulletActiveClass: 'sf-pagination__bullet_active',
        clickable: true,
      },
      spaceBetween: 0,
      breakpoints: {
        768: {
          spaceBetween: 20,
        },
        1400: {
          spaceBetween: 30,
        },
      },
    });
  }

  const productCarousels = document.querySelectorAll('.product-carousel');
  if (productCarousels) productCarousels.forEach(carousel => {
    new Swiper(carousel, {
      modules: [ Autoplay ],
      loop: true,
      speed: 400,
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
      },
      slidesPerView: 2,
      spaceBetween: 10,
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
  });

  const categoryCarousel = document.querySelector('.category-carousel');
  if (categoryCarousel) {
    const categoryCarouselSlider = categoryCarousel.querySelector('.category-carousel__slider');
    new Swiper(categoryCarouselSlider, {
      modules: [Autoplay, Navigation, Pagination],
      loop: true,
      speed: 500,
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
      },
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: categoryCarousel.querySelector('.sf-pagination'),
        bulletClass: 'sf-pagination__bullet',
        bulletActiveClass: 'sf-pagination__bullet_active',
        clickable: true,
      },
    });
  }

  const productGallery = document.querySelector('.product__gallery');
  if (productGallery) {
    const productImage = document.querySelector('.product__image img');
    const productGalleryItems = document.querySelectorAll('.product__gallery-item');
    productGalleryItems.forEach(item => {
      item.addEventListener('click', () => {
        productImage.setAttribute('src', item.dataset.src);
        productGallery.querySelector('.product__gallery-item_active').classList.remove('product__gallery-item_active');
        item.classList.add('product__gallery-item_active');
      });
    });

    new Swiper(productGallery, {
      modules: [Autoplay, Navigation],
      speed: 500,
      slidesPerView: 3,
      spaceBetween: 10,
      loopAdditionalSlides: 10,
    });
  }
});